var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6146 8.90228C38.6417 9.28126 38.6417 9.66033 38.6417 10.0393C38.6417 21.5988 29.8435 34.9181 13.763 34.9181C8.80884 34.9181 4.2067 33.4832 0.335449 30.9927C1.03934 31.0739 1.71606 31.101 2.44703 31.101C6.53477 31.101 10.2978 29.7204 13.3027 27.3652C9.45856 27.2839 6.23703 24.7663 5.12708 21.3011C5.66855 21.3822 6.20995 21.4364 6.77851 21.4364C7.56356 21.4364 8.34869 21.3281 9.07957 21.1387C5.073 20.3265 2.06796 16.8072 2.06796 12.557V12.4487C3.23199 13.0984 4.58568 13.5045 6.02037 13.5586C3.66514 11.9884 2.12212 9.30834 2.12212 6.27631C2.12212 4.65204 2.55519 3.16311 3.31324 1.86366C7.61764 7.16968 14.0878 10.6348 21.3429 11.0139C21.2076 10.3641 21.1263 9.68741 21.1263 9.01061C21.1263 4.19181 25.0246 0.266479 29.8704 0.266479C32.3881 0.266479 34.6621 1.32227 36.2593 3.02778C38.2355 2.64879 40.1305 1.91783 41.809 0.916202C41.1592 2.94661 39.7786 4.65213 37.9648 5.73491C39.7245 5.5455 41.43 5.05811 43.0001 4.38139C41.8092 6.1139 40.3202 7.65691 38.6146 8.90228Z",
    fill: "url(#paint0_linear_203_4011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_4011",
    x1: 0.335449,
    y1: 34.9181,
    x2: 43.0001,
    y2: 34.9181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5773FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1b20db83db86c8bdd2fbac12667dc194.svg";
export { ForwardRef as ReactComponent };